import { memo, useState } from 'react';

import { emojiFont } from '../icon-picker/picker/emoji/emoji-picker.css';
import {
  emojiToFilename,
  getEmojiFileUrl,
  isEmojiArtworkMissing,
  markEmojiArtworkMissing,
} from './emoji-asset';

/**
 * Renders an emoji from the bundled PNG artwork with a native-text fallback
 * (a few rare symbols like ♀ ♂ ⚕ have no artwork upstream and render with
 * the bundled emoji font stack).
 */
export const EmojiImage = memo(function EmojiImage({
  unicode,
  alt,
}: {
  unicode: string;
  alt?: string;
}) {
  const filename = emojiToFilename(unicode);
  // `failed` is keyed by filename so a changed `unicode` prop on a mounted
  // component re-evaluates the fallback state instead of reusing the stale
  // failure of the previous emoji.
  const [state, setState] = useState(() => ({
    filename,
    failed: isEmojiArtworkMissing(filename),
  }));
  const failed = state.filename === filename ? state.failed : false;

  if (failed) {
    return <span className={emojiFont}>{unicode}</span>;
  }

  return (
    <img
      src={getEmojiFileUrl(filename)}
      alt={alt ?? unicode}
      title={alt}
      draggable={false}
      loading="lazy"
      decoding="async"
      style={{ width: '1em', height: '1em' }}
      onError={() => {
        markEmojiArtworkMissing(filename);
        setState({ filename, failed: true });
      }}
    />
  );
});
